import React from "react";

export default function Head() { 
    return (
        <div className="card-img">
        </div>
    );
}
